export default {
  slug: "dental-extractions-in-guwahati",
  title: "Dental Extractions in Guwahati",
  subtitle:
    "Dental Extractions- Safe, simple, stress-free extractions",

  heroImage:
    "/dental-services/dental-extractions/tooth-extraction-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Dental Extractions at Magnum Dental Clinic, Guwahati",
      content: `
Dental extraction is a procedure in which a tooth is safely removed from its socket when it can no longer be saved. While dentists always try to preserve natural teeth, extraction becomes necessary in cases of severe decay, infection, trauma, or overcrowding.

At Magnum Dental Clinic, Guwahati, we perform gentle, safe, and comfortable dental extractions using modern techniques to minimize pain and promote faster healing.
      `,
    },

    {
      type: "image",
      images: [
        "/dental-services/dental-extractions/teeth-extraction-in-guwahati.webp",
        "/dental-services/dental-extractions/teeth-removal-in-guwahati.webp",
        "/dental-services/dental-extractions/tooth-removal-guwahati.webp",
      ],
      caption: "Images are for illustrative purposes only",
    },

    {
      type: "text",
      heading: "Why Dental Extractions Are Needed",
      content: `
Dental extractions help to:

✔ Eliminate pain and infection  
✔ Prevent spread of bacteria  
✔ Protect surrounding teeth and gums  
✔ Improve overall oral health  
✔ Prepare the mouth for orthodontic or prosthetic treatment
      `,
    },

    {
      type: "text",
      heading: "When Do You Need a Tooth Extraction?",
      content: `
A dentist can clinically determine if a tooth needs removal. You should visit a dentist immediately if you experience:

✔ Severe tooth pain  
✔ Swelling in gums or face  
✔ Pus discharge or abscess  
✔ Deep cavities beyond repair  
✔ Loose teeth due to gum disease  
✔ Impacted wisdom teeth  
✔ Fractured or broken teeth  
✔ Overcrowding before braces  

Delaying treatment can lead to serious infections and complications.
      `,
    },

    {
      type: "text",
      heading: "Is Tooth Extraction Painful?",
      content: `
No. With modern anesthesia and gentle techniques, dental extractions are comfortable and mostly painless. You may feel slight pressure, but not pain.

At Magnum Dental Clinic, Guwahati, patient comfort is our top priority at every step.
      `,
    },

    {
      type: "text",
      heading: "What Happens After a Tooth Extraction?",
      content: `
After extraction, a blood clot forms in the socket to support healing. Following post-extraction instructions is essential for quick recovery.

We provide complete aftercare guidance including:

✔ What to eat  
✔ How to clean the area  
✔ Pain management tips  
✔ Healing timeline
      `,
    },

    {
      type: "text",
      heading: "How Long Does It Take to Heal?",
      content: `
Initial healing usually takes 7–10 days, while complete bone healing may take a few weeks. Healing time varies depending on the complexity of the extraction.
      `,
    },

    {
      type: "text",
      heading: "Replacing a Missing Tooth",
      content: `
After extraction, replacing the missing tooth is important to prevent shifting of nearby teeth. Replacement options include:

✔ Dental Implants  
✔ Bridges  
✔ Dentures  

At Magnum Dental Clinic, Guwahati, we guide you in choosing the best solution based on your needs and budget.
      `,
    },

    {
      type: "text",
      heading: "Why Choose Magnum Dental Clinic for Tooth Extraction in Guwahati?",
      content: `
✔ Experienced dentists  
✔ Advanced equipment  
✔ Comfortable procedures  
✔ Strict sterilization protocols  
✔ Affordable treatment options  
✔ Personalized patient care  

We are a trusted dental clinic for safe tooth extraction in Guwahati.
      `,
    },
  ],

  faqs: [
    {
      q: "Can I eat after tooth extraction?",
      a: "You should wait until the anesthesia wears off. Avoid hot foods and stick to soft foods for the first 24 hours.",
    },
    {
      q: "How long does a tooth extraction take?",
      a: "Most simple extractions take about 30 minutes.",
    },
    {
      q: "Will I get swelling after extraction?",
      a: "Mild swelling can occur but usually subsides within a few days.",
    },
    {
      q: "When can I return to work after extraction?",
      a: "Most patients return to work the next day after a simple extraction.",
    },
  ],

  cta: {
    heading: "Book Dental Extraction in Guwahati",
    description: `
If you’re experiencing tooth pain or infection, don’t delay treatment. Early care can prevent serious complications.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 for consultation and pricing details

🦷 Gentle Care. Safe Hands. Healthy Smiles.
    `,
    buttonText: "Book Dental Extraction Appointment",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
